// extracted by mini-css-extract-plugin
module.exports = {"chatSliderContainer":"az_a2","chatSliderImgContent":"az_b2","liveChat":"az_c2","sr":"az_d2","chatBtn":"az_e2"};